<template>
  <v-stepper-content step="4" v-if="perm !== 'student' || att.stat !== 'inprogress'">
    <v-content fluid grid-list-lg style="padding: 0;">
      <v-layout row wrap>
        <v-flex xs12>
          <v-subheader class="pl-0">Step Grades</v-subheader>
          <small v-if="!Array.isArray(errs.grades)" class="error--text">{{errs.grades}}</small>
          <v-expansion-panel>
            <v-expansion-panel-content
              v-for="(step, i) in steps"
              :key="step._id"
              :value="i === steps.findIndex(step => typeof step.grade === 'undefined')"
            >
              <div slot="header" class="grades-header text-capitalize">
                <h3>
                  <v-icon v-if="typeof step.grade !== 'number'" left>far fa-minus</v-icon>
                  <v-icon v-else left>fal fa-check</v-icon>
                  {{step.name}}
                  <small
                    v-if="Array.isArray(errs.grades) && errs.grades[i]"
                    class="error--text"
                  >
                    {{`
                      ${errs.grades[i].stepId || ''}
                      ${errs.grades[i].grade || ''}
                      ${errs.grades[i].stepName || ''}
                      ${errs.grades[i].gradeName || ''}
                      ${errs.grades[i].category || ''}
                    `}}
                  </small>
                </h3>
              </div>
              <v-card>
                <v-card-text :style="`background: ${$vuetify.dark ? '#212121' : '#eee' }`">
                  <v-btn
                    v-for="g in step.grades"
                    :key="g.value"
                    :color="typeof step.grade === 'number' ? 'default' : 'secondary'"
                    @click.stop="addGrade(step._id, g.value); clearErr('grades');"
                    :disabled="step.grade === g.value"
                  >
                    {{g.title}}
                  </v-btn>
                </v-card-text>
              </v-card>
            </v-expansion-panel-content>
          </v-expansion-panel>
          <br>
          <h3 v-if="att.stat !== 'inprogress'">Total Grade: {{(att.grade * 100).toFixed(2)}}%</h3>
        </v-flex><v-flex xs12>
          <v-subheader class="pl-0">Comments for the Student</v-subheader>
          <v-textarea
            label="Comments"
            v-model="att.comments.staff"
            :disabled="lock"
            :error-messages="errs.comments.staff"
            @change="$emit('save'); clearErr('comments.staff')"
            :counter="4096"
          />
        </v-flex><v-flex xs12 v-if="perm !== 'student'">
          <v-subheader class="pl-0">Comments for other Supervisors</v-subheader>
          <small>This is only visible to other supervisors, and not the student</small>
          <v-textarea
            label="Comments"
            v-model="att.comments.staffPrivate"
            :disabled="lock"
            :error-messages="errs.comments.staffPrivate"
            @change="$emit('save'); clearErr('comments.staffPrivate')"
            :counter="4096"
          />
        </v-flex><v-flex xs12  v-if="perm !== 'student'">
          <v-subheader class="pl-0">
            <v-icon small>fas fa-flag</v-icon>
            &nbsp;
            Manual Flags
          </v-subheader>
          <v-autocomplete
            label="Flags"
            :items="flags"
            item-text="name"
            item-value="_id"
            v-model="att.flagIds"
            :disabled="lock"
            :error-messages="errs.flagIds"
            @change="$emit('save'); clearErr('flagIds')"
            multiple
            chips deletable-chips
          >
            <template slot="selection" slot-scope="data">
              <v-chip
                :selected="data.selected"
                close
                class="chip--select-multi"
                @input="att.flagIds.splice(att.flagIds.indexOf(data.item._id), 1)"
              >
                <v-icon small :color="data.item.colour">fas fa-flag</v-icon>
                &nbsp;
                {{ data.item.name }}
              </v-chip>
            </template>
          </v-autocomplete>
        </v-flex>
      </v-layout>
    </v-content>
    <v-btn @click="$emit('update:step', 3)" >Back</v-btn>
    <v-btn
      v-if="att.stat === 'inprogress'"
      color="secondary"
      @click="$emit('save', 'complete')"
      :disabled="!valid || (att.stat !== 'inprogress' && !changed)"
      :loading="loading"
    >
      Save &amp; Submit
    </v-btn>
  </v-stepper-content>
</template>

<script>
import { mapGetters, mapState } from 'vuex';
import cloneDeep from 'lodash/cloneDeep';
import set from 'lodash/set';
import attemptEq from '../attemptEq';

export default {
  props: {
    attempt: {
      type: Object,
      default: () => ({ comments: {} }),
    },
    errs: {
      type: Object,
      default: () => ({ comments: {} }),
    },
    lock: {
      type: Boolean,
      default: false,
    },
    loading: {
      type: Boolean,
      default: false,
    },
    changed: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      att: { comments: {} },
    };
  },
  computed: {
    ...mapState('auth', ['user']),
    ...mapGetters('steps', { stepsFind: 'find' }),
    ...mapGetters('flags', { flagsFind: 'find' }),
    perm() { return this.user && this.user.perm; },
    id() { return this.att && this.att._id; },
    valid() {
      return this.att.grades && this.att.stepIds
      && this.att.grades.length
      && this.att.grades.length === this.att.stepIds.length;
    },
    steps() {
      const steps = this.stepsFind({
        query: { _id: { $in: this.att.stepIds || [] }, $sort: { name: 1 } },
      }).data;
      return steps.map(step => ({
        ...step,
        grade: (this.att.grades.find(gr => gr.stepId === step._id) || {}).grade,
      }));
    },
    flags() {
      const flags = this.flagsFind({
        query: { manual: true, $sort: { name: 1 } },
      }).data;
      return flags;
    },
    nextGrade() {
      return (this.steps.find(step => typeof step.grade !== 'number') || {})._id;
    },
  },
  methods: {
    setAtt() {
      if (!attemptEq(this.att, this.attempt)) this.att = cloneDeep(this.attempt);
    },
    clearErr(i) {
      const errs = cloneDeep(this.errors);
      set(errs, i, '');
      this.$emit('update:errors', errs);
    },
    addGrade(stepId, grade) {
      if (this.lock) return;
      const data = { stepId, grade };
      const i = this.att.grades.findIndex(g => g.stepId === stepId);
      if (i !== -1) this.att.grades.splice(i, 1, data);
      else this.att.grades.push(data);
      setTimeout(() => this.$emit('save'), 10);
    },
  },
  mounted() { this.setAtt(); },
  watch: {
    attempt: {
      handler() { this.setAtt(); },
      deep: true,
    },
    att: {
      handler() {
        if (!attemptEq(this.att, this.attempt)) this.$emit('update:attempt', this.att);
      },
      deep: true,
    },
    valid() { this.$emit('update:valid', this.valid); },
  },
};
</script>
